<template>
  <div class="form-nested-accordion">
    <form @submit.prevent="register" action="#" method="get">
      <div class="row">
        <div class="col-md-12">
          <p>Fique por dentro de todas as vantagens que só a Aldo Crazy People pode oferecer.</p>
          <p>Garanta o recebimento dos e-mails da Aldo clicando aqui e escolhendo a opção "sim" e fique sempre atualizado de nossas promoções, caso você não queira mais receber nossos e-mails comerciais escolha a opção "não".</p>
          <p>Um original e exclusivo sistema de e-commerce, que integra soluções de logística, informação e promoções, garantindo mais facilidade e comodidade para os participantes da Aldo Crazy People. Disponibilizando aos clientes cadastrados, recursos que diferenciam os parceiros da empresa junto à concorrência.</p>
          <h3
            class="text-center"
          >Você quer usufruir de todas estas vantagens recebendo o Aldo Crazy Mail?</h3>
          <div class="text-center">
            <FormHelper
              :inputVar="frmMarketing.receber"
              :form="frmMarketing"
              :options="yesOrNoOptions()"
              type="radio"
              label
            ></FormHelper>
          </div>
          <p class="text-center">
            <button aria-label="Confirmar" class="btn primary-button ">Confirmar</button>
          </p>
          <div class="alert alert-danger" role="alert">
              IMPORTANTE: O ALDO CRAZY MAIL também inclui todos os e-mail's enviados pelo sistema da Aldo Componentes: Notas Fiscais, Promoções, Confirmação do Processamento de Pedidos pela Internet, etc.
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import FormHelper from "../FormHelper.vue";

export default {
  name: "EmailMarketing",
  components: {
    FormHelper
  },  
  props: {
    msg: String
  },
  data() {
    return {
      frmMarketing: {
        attemptSubmit: false,
        receber: new this.formInput(false, true)
      }
    };
  },
  methods: {
    formInput: function(required, value) {
      // Define um padrão para estrutura de cada input do formulário
      this.required = required !== undefined ? required : true;
      this.value = value !== undefined ? value : "";

      this.validation = {
        // Status verifica se o input é obrigatório e possui valor, e retorna verdadeiro ou falso
        // Para que o usuário seja barrado em caso de um submit sem dados
        status: !(this.required && this.value === ""),
        message: this.required ? "Por favor, preencha o campo acima" : ""
      };
    },
    yesOrNoOptions: function() {
      const options = [
        { code: 1, label: "Sim", value: true },
        { code: 2, label: "Não", value: false }
      ];

      return options;
    },
    register : function(){
        this.frmMarketing.attemptSubmit = true;        
        
        //Colocar codigo ajax aqui
        var xhr = new XMLHttpRequest();
        xhr.onload = () => {
          if (xhr.status == 200){
            if (this.frmMarketing.receber.value)
            {
              swal({
                title: "Alteração realizada com sucesso",
                text: "O recebimento de email foi ativado",
                icon: "success"
              })
            }
            else{
              swal({
                title: "Alteração realizada com sucesso",
                text: "O recebimento de email foi desativado",
                icon: "success"
              })
            }
          }
          else
          {
            swal({
              title: "Erro ao alterar o recebimento de email",
              icon: "error"
            })
          }
        }

        xhr.open("POST", this.$apiUrl + "Cliente.svc/alterarreceberemail");
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.withCredentials = true;
        xhr.send(JSON.stringify({
          receber: this.frmMarketing.receber.value
        }))
    }
  }
};
</script>
